"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOfferDetailsDtoActionTypeEnum = exports.GetOfferDetailsDtoActionMadeByEnum = exports.GetOfferDetailsDtoSignatureStatusEnum = exports.GetOfferDetailsDtoStatusEnum = void 0;
exports.instanceOfGetOfferDetailsDto = instanceOfGetOfferDetailsDto;
exports.GetOfferDetailsDtoFromJSON = GetOfferDetailsDtoFromJSON;
exports.GetOfferDetailsDtoFromJSONTyped = GetOfferDetailsDtoFromJSONTyped;
exports.GetOfferDetailsDtoToJSON = GetOfferDetailsDtoToJSON;
exports.GetOfferDetailsDtoToJSONTyped = GetOfferDetailsDtoToJSONTyped;
/**
 * @export
 */
exports.GetOfferDetailsDtoStatusEnum = {
    Draft: 'draft',
    UnderReview: 'under_review',
    Pending: 'pending',
    Reserved: 'reserved',
    Accepted: 'accepted',
    Rejected: 'rejected',
    Countered: 'countered',
    Withdrawn: 'withdrawn',
    Expired: 'expired',
    Closed: 'closed'
};
/**
 * @export
 */
exports.GetOfferDetailsDtoSignatureStatusEnum = {
    OfferorSignPending: 'offeror_sign_pending',
    OfferorSigned: 'offeror_signed',
    OffereeSignPending: 'offeree_sign_pending',
    OffereeSigned: 'offeree_signed'
};
/**
 * @export
 */
exports.GetOfferDetailsDtoActionMadeByEnum = {
    Vendor: 'vendor',
    Admin: 'admin',
    Agent: 'agent',
    Buyer: 'buyer'
};
/**
 * @export
 */
exports.GetOfferDetailsDtoActionTypeEnum = {
    Accept: 'accept',
    Reject: 'reject',
    Counter: 'counter',
    Reserve: 'reserve'
};
/**
 * Check if a given object implements the GetOfferDetailsDto interface.
 */
function instanceOfGetOfferDetailsDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('signatureStatus' in value) || value['signatureStatus'] === undefined)
        return false;
    if (!('isCounterOffer' in value) || value['isCounterOffer'] === undefined)
        return false;
    if (!('offerPrice' in value) || value['offerPrice'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    return true;
}
function GetOfferDetailsDtoFromJSON(json) {
    return GetOfferDetailsDtoFromJSONTyped(json, false);
}
function GetOfferDetailsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'status': json['status'],
        'signatureStatus': json['signatureStatus'],
        'isCounterOffer': json['isCounterOffer'],
        'acceptedAt': json['acceptedAt'] == null ? undefined : json['acceptedAt'],
        'rejectedAt': json['rejectedAt'] == null ? undefined : json['rejectedAt'],
        'rejectedReason': json['rejectedReason'] == null ? undefined : json['rejectedReason'],
        'settlementDate': json['settlementDate'] == null ? undefined : json['settlementDate'],
        'contractSubjects': json['contractSubjects'] == null ? undefined : json['contractSubjects'],
        'depositAmount': json['depositAmount'] == null ? undefined : json['depositAmount'],
        'offerPrice': json['offerPrice'],
        'expiresAt': json['expiresAt'] == null ? undefined : json['expiresAt'],
        'actionMadeBy': json['actionMadeBy'] == null ? undefined : json['actionMadeBy'],
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
        'createdAt': json['createdAt'],
    };
}
function GetOfferDetailsDtoToJSON(json) {
    return GetOfferDetailsDtoToJSONTyped(json, false);
}
function GetOfferDetailsDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'status': value['status'],
        'signatureStatus': value['signatureStatus'],
        'isCounterOffer': value['isCounterOffer'],
        'acceptedAt': value['acceptedAt'],
        'rejectedAt': value['rejectedAt'],
        'rejectedReason': value['rejectedReason'],
        'settlementDate': value['settlementDate'],
        'contractSubjects': value['contractSubjects'],
        'depositAmount': value['depositAmount'],
        'offerPrice': value['offerPrice'],
        'expiresAt': value['expiresAt'],
        'actionMadeBy': value['actionMadeBy'],
        'actionType': value['actionType'],
        'createdAt': value['createdAt'],
    };
}
